import { currentSharepointFolderUserPermissions } from "../../../src/taskpane/redux/models/reduxModels";

export type CurrentFolderPermissionStatus = "unknown" | "loading" | "loaded" | "failed";

export interface CurrentFolderPermissionState {
  directoryRequestKey?: string;
  identityKey?: string;
  resolvedSharePointUniqueId?: string;
  permissions?: currentSharepointFolderUserPermissions;
  status: CurrentFolderPermissionStatus;
  errorMessage?: string;
}

export const initialCurrentFolderPermissionState: CurrentFolderPermissionState = {
  status: "unknown",
};
